/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-undef */
import { Form, List, Radio, Space } from 'antd';
import React from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import AudioButton from '../AudioButton';
import QuestionHeader from '../QuestionHeader';
import styles from './styles.module.css';

function TickTF({ data, userData, onSubmit, questionIndex = 0 }) {
  const arrayTF = [true, false];
  const [selectedAnswers, setSelectedAnswers] = React.useState({});
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (userData) {
      let userSelect = {};
      userData.answers.forEach((item, index) => {
        userSelect = { ...userSelect, [index]: item.selected };
      });
      setSelectedAnswers(userSelect);
      // form.setFieldsValue(userSelect);
    }
  }, [form, userData]);

  return (
    <Card>
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='TickTF' />
      </CardHeader>

      <CardBody style={{ minHeight: 300, maxWidth: 900 }}>
        <Space direction='vertical'>
          <AudioButton audioUrl={data.audioUrl} />
          {/* Paragraph */}
          <span className='questionText'>{data.questionText}</span>
          {/* Question */}
          <span className='questionText'>{data.question}</span>
        </Space>
        <Form
          form={form}
          onFieldsChange={() => {
            setSelectedAnswers(form.getFieldValue());
          }}
        >
          <List
            size='small'
            split={false}
            dataSource={data.answers}
            header={
              <div className='d-flex justify-content-end'>
                <Space size='large'>
                  {['T', 'F'].map((item, index) => (
                    <div key={index} className={styles.check}>
                      <span className={styles[item]}>{item}</span>
                    </div>
                  ))}
                </Space>
              </div>
            }
            renderItem={(item, index) => (
              <List.Item key={index} className='d-flex flex-nowrap p-0' style={{ height: '55px' }}>
                <span style={{ width: '70%', fontSize: 20 }}>
                  <b>{data.answers.length > 1 && `${index + 1}. `}</b>
                  <span>{item.answer}</span>
                </span>
                <Form.Item name={index}>
                  <Radio.Group>
                    <Space size='large' className='mt-10'>
                      {arrayTF.map((X, i) => (
                        <div key={i} className={styles.box}>
                          <Radio.Button value={X} className={styles.check}>
                            {selectedAnswers[index] === X && <i className='fa fa-check fa-lg text-success' />}
                          </Radio.Button>
                        </div>
                      ))}
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </List.Item>
            )}
          />
        </Form>
      </CardBody>
      <CardFooter>
        <Button
          color='primary'
          onClick={() => {
            const answers = data.answers.map((item, index) => {
              const selected = selectedAnswers[index];
              return { ...item, selected };
            });
            const result = answers.every((x) => x.isCorrect === x.selected);
            if (onSubmit && typeof onSubmit === 'function') onSubmit({ answers, result });
          }}
        >
          Submit
          <i className='fas fa-arrow-right ml-3' />
        </Button>
      </CardFooter>
    </Card>
  );
}

export default TickTF;
